/**
 * Password validation utility
 * Validates that password meets security requirements:
 * - Minimum 8 characters
 * - At least one uppercase letter
 * - At least one lowercase letter
 * - At least one number
 * - At least one special character
 */

export function validatePassword(password) {
  if (!password) {
    return {
      isValid: false,
      errors: ['Vui lòng nhập mật khẩu'],
    };
  }

  const errors = [];
  
  // Minimum 8 characters
  if (password.length < 8) {
    errors.push('Mật khẩu phải có ít nhất 8 ký tự');
  }
  
  // At least one uppercase letter
  if (!/[A-Z]/.test(password)) {
    errors.push('Mật khẩu phải chứa ít nhất một chữ cái viết hoa');
  }
  
  // At least one lowercase letter
  if (!/[a-z]/.test(password)) {
    errors.push('Mật khẩu phải chứa ít nhất một chữ cái viết thường');
  }
  
  // At least one number
  if (!/[0-9]/.test(password)) {
    errors.push('Mật khẩu phải chứa ít nhất một số');
  }
  
  // At least one special character
  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    errors.push('Mật khẩu phải chứa ít nhất một ký tự đặc biệt');
  }
  
  return {
    isValid: errors.length === 0,
    errors,
  };
}

export function getPasswordRequirements() {
  return [
    'Tối thiểu 8 ký tự',
    'Ít nhất một chữ cái viết hoa (A-Z)',
    'Ít nhất một chữ cái viết thường (a-z)',
    'Ít nhất một số (0-9)',
    'Ít nhất một ký tự đặc biệt (!@#$%^&*...)',
  ];
}

